import { connect } from 'react-redux';

import addAbilityToOpenModal from '../../../utilities/modalHOC';
import { getPermissions } from '../../Login/selectors';
import { loadQuals, loadRates } from '../../Rates/actionsSagas';
import {
  getPagination,
  getPaginationQuals,
  getQuals,
  getRates,
} from '../../Rates/selectors';
import {
  setConsultDeleteResponse,
  setSelectedQual,
  setSelectedRate,
  setViewRates,
  updateGroupToDelete,
} from '../actions';
import {
  addMemberInGroup,
  consultDelete,
  deleteGroup,
  loadAllAdmins,
  loadGroupsForStudyProgram,
  loadRolesForRates,
  updatePrimaryWriter,
} from '../actionsSagas';
import {
  getAdmins,
  getDeleteResponse,
  getGroupsForRole,
  getGroupToDelete,
  getRoles,
  getSelectedQual,
  getSelectedRate,
  getViewRates,
  getWaiting,
} from '../selectors';
import Groups from './Groups';

const mapStateToProps = (state) => ({
  rates: getRates(state),
  roles: getRoles(state),
  groups: getGroupsForRole(state),
  admins: getAdmins(state),
  isWaiting: getWaiting(state),
  isLoadingMembers: getWaiting(state, 'groupsForStudyProgram'),
  ratesPagination: getPagination(state),
  paginationQuals: getPaginationQuals(state),
  quals: getQuals(state),
  deleteResponse: getDeleteResponse(state),
  groupToDelete: getGroupToDelete(state),
  permissions: getPermissions(state),
  rate: getSelectedRate(state),
  qual: getSelectedQual(state),
  viewRates: getViewRates(state),
});

const mapDispatchToProps = (dispatch) => ({
  loadRates: (page) => dispatch(loadRates(page)),
  loadQuals: (page) => dispatch(loadQuals(page)),
  loadRoles: () => dispatch(loadRolesForRates()),
  loadAdmins: () => dispatch(loadAllAdmins()),
  loadGroupsForStudyProgram: (type, typeId) =>
    dispatch(loadGroupsForStudyProgram(type, typeId)),
  deleteGroup: (groupId) => dispatch(deleteGroup(groupId)),
  addMemberInGroup: (fields, rate, role, type) =>
    dispatch(addMemberInGroup(fields, rate, role, type)),
  consultDelete: (group) => dispatch(consultDelete(group)),
  updateDeleteResponseState: (value) =>
    dispatch(setConsultDeleteResponse(value)),
  updateGroupToDelete: (group) => dispatch(updateGroupToDelete(group)),
  updatePrimaryWriter: (writer, writerToDelete) =>
    dispatch(updatePrimaryWriter(writer, writerToDelete)),
  setSelectedRate: (rate) => dispatch(setSelectedRate(rate)),
  setSelectedQual: (qual) => dispatch(setSelectedQual(qual)),
  setViewRates: (viewRates) => dispatch(setViewRates(viewRates)),
});

export default addAbilityToOpenModal(
  connect(mapStateToProps, mapDispatchToProps)(Groups),
);
